const TEMPLATE_SELECTOR = '.js-counter';
const ANIMATED_NUMBER_CLASS = 'js-animated-number';
const INITIAL_CLASS = 'initiated';
const INITIAL_VALUE = '0';
const animateNumber = (numberEl, duration) => {
    let startTimestamp = null;
    let start = 0;
    let end = parseFloat(numberEl.dataset.number);
    let decimal = numberEl.dataset.number.toString().split('.');
    let num = 0;

    const step = (timestamp) => {
        if (!startTimestamp) startTimestamp = timestamp;

        const progress = Math.min((timestamp - startTimestamp) / duration, 1);

        if (decimal.length > 1) {
            num = (progress * (end - start) + start).toFixed(decimal[1].length);
        } else {
            num = Math.floor(progress * (end - start) + start);
        }

        // Format with comma as thousands separator
        const formatted = num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
        numberEl.innerHTML = formatted;

        if (progress < 1) {
            window.requestAnimationFrame(step);
        }
    };

    window.requestAnimationFrame(step);
};

export const initCounterItem = (counter, duration = 1000) => {
    counter.classList.add(INITIAL_CLASS);

    let numberEl = counter.querySelector(`.${ANIMATED_NUMBER_CLASS}`);

    if (!numberEl) {
        return;
    }

    let number = numberEl.innerHTML;
    let firstShow = true;

    if (!isNaN(number) && isFinite(number)) {
        numberEl.innerHTML = INITIAL_VALUE;

        const intersectionCallback = (entries) => {
            entries.forEach((entry) => {
                if (entry.isIntersecting && firstShow) {
                    setTimeout(() => {
                        animateNumber(numberEl, duration);
                    }, 800);
                    firstShow = false;
                }
            });
        };

        let options = {
            root: null,
            rootMargin: '0px',
            threshold: 1.0,
        };

        let observer = new IntersectionObserver(intersectionCallback, options);
        observer.observe(counter);

        return () => {
            observer.disconnect();
        };
    } else {
        return;
    }
};

export const Stats = () => {
    document.querySelectorAll(TEMPLATE_SELECTOR).forEach((el) => {
        initCounterItem(el);
    });
};
